import {
  FETCH_WAREHOUSE,
  SUBMIT_WAREHOUSE,
  DELETE_WAREHOUSE,
  REFRESH_WAREHOUSE_DATATABLES,
  RESET_STORE,
} from '../actions/_types';

const initialState = {
  result: [],
  submitResult: {},
  deleteResult: {},

  refresh: false,
};

export default function warehouse(state = initialState, action) {
  switch (action.type) {
    case FETCH_WAREHOUSE:
      return {
        ...state,
        result: action.result,
      };

    case SUBMIT_WAREHOUSE:
      return {
        ...state,
        submitResult: action.result,
      };

    case DELETE_WAREHOUSE:
      return {
        ...state,
        deleteResult: action.result,
      };

    case REFRESH_WAREHOUSE_DATATABLES:
      return {
        ...state,
        refresh: !state.refresh,
      };

    case RESET_STORE:
      return { ...initialState };

    default:
      return state;
  }
}
